
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(154|179|385|887)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
